import pl from './pl.json'
const trans = pl
export default trans
